import React, { useEffect, useState } from "react";
import axios from "axios";
import JSZip from "jszip";
import restApi from "../../services/ApiServices/RestApi";
import { useLocation, useNavigate } from "react-router-dom";
import spinner from "../../assets/spiner.svg";

const ViewLoader = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Two-stage loading
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [loadingData, setLoadingData] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadViewerData = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const access = params.get("access");
        if (!access) throw new Error("Missing access token in URL");

        //Authenticate link
        setIsAuthenticating(true);
        const tokenResp = await restApi.get(
          `open-access/token?access=${access}`
        );
        const { viewerToken } = tokenResp.data;
        if (!viewerToken) throw new Error("No viewer token returned");

        //Load data
        setIsAuthenticating(false);
        setLoadingData(true);

        const fileResp = await restApi.get(
          `open-access/secure-viewer?token=${viewerToken}`
        );
        const { dicomUrl, resultUrl } = fileResp.data || {};
        if (!dicomUrl || !resultUrl)
          throw new Error("Missing DICOM or result URL");

        // download & unzip DICOM files
        const zipBuf = await axios.get(dicomUrl, {
          responseType: "arraybuffer",
        });
        const zip = await JSZip.loadAsync(zipBuf.data);
        const files = await Promise.all(
          Object.values(zip.files)
            .filter((f) => !f.dir)
            .map(async (f) => new File([await f.async("blob")], f.name))
        );
        if (files.length === 0) throw new Error("No DICOM files found in ZIP");

        // fetch JSON result
        const resultResp = await axios.get(resultUrl);

        // temporary session user
        sessionStorage.setItem(
          "loggedInUser",
          JSON.stringify({
            profile: { First_name: "OpenAccess", Last_name: "Viewer" },
            roles: ["viewer"],
          })
        );

        // navigate to viewer
        navigate("/open-access/dicom-viewer", {
          state: { dicomFiles: files, jsonData: resultResp.data },
        });
      } catch (err) {
        console.error("ViewLoader error:", err);
        setError(err.message || "Unknown error occurred");
      } finally {
        setIsAuthenticating(false);
        setLoadingData(false);
      }
    };

    loadViewerData();
  }, [location.search, navigate]);

  if (isAuthenticating)
    return <FullScreenLoader message="Authenticating link…" />;

    {loadingData && (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center z-50">
        <img
          src={spinner}
          alt="Loading…"
          className="animate-spin h-16 w-16 filter invert"
        />
        <p className="mt-4 text-white text-lg font-medium">
          Loading viewer data…
        </p>
      </div>
    )}
  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
        <div className="p-6 bg-white rounded-lg shadow-lg text-center">
          <p className="text-red-500 font-medium mb-4">Link is expired</p>
        </div>
      </div>
    );
  }

  return null;
};

const FullScreenLoader = ({ message }) => (
  <div
    className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-60 z-50"
    role="alert"
    aria-busy="true"
    aria-label={message}>
    <img
      src={spinner}
      alt="Loading…"
      className="animate-spin h-16 w-16 filter invert"
    />
    <p className="mt-4 text-white text-lg font-medium">{message}</p>
  </div>
);

export default ViewLoader;
